import { CaretLeft } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

/**
 * "Learn More" page for the Credit Limit Eligibility flow. Reached from the
 * "Learn More" button in the eligibility modal on the home page.
 */
const CreditLimitInfo = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto px-5 py-10">
      <button
        onClick={() => navigate(-1)}
        type="button"
        className="flex items-center gap-2 text-deepBlue font-medium mb-6"
      >
        <CaretLeft /> <span>Back</span>
      </button>

      <h1 className="text-3xl font-semibold mb-8">Credit Limit Eligibility</h1>

      <div className="flex flex-col gap-8 text-gray-700 leading-relaxed">
        <section className="flex flex-col gap-2">
          <h2 className="text-xl font-semibold text-gray-900">
            What is a Credit Limit?
          </h2>
          <p>
            Your credit limit is the maximum amount Visaro may approve you to
            access.
          </p>
          <p>
            Visaro reviews your eligibility and may assign a personalized limit.
            If declined, you can request another review.
          </p>
          <p>Claiming an assigned limit submits a loan request. Funds become available after partner approval and disbursement.</p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-xl font-semibold text-gray-900">
            Why check my credit limit?
          </h2>
          <p>Checking your limit lets you:</p>
          <ul className="list-disc pl-6 flex flex-col gap-1">
            <li>Know how much you qualify for</li>
            <li>Access funds faster when needed</li>
            <li>Submit a loan request within an assigned limit</li>
            <li>Plan ahead with confidence</li>
          </ul>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-xl font-semibold text-gray-900">
            How is my limit determined?
          </h2>
          <p>Your credit limit is based on several factors, including:</p>
          <ul className="list-disc pl-6 flex flex-col gap-1">
            <li>Identity verification (BVN &amp; NIN)</li>
            <li>Banking activity</li>
            <li>Income and employment</li>
            <li>Spending and repayment behaviour</li>
            <li>Internal risk assessment</li>
          </ul>
          <p>Every application is assessed individually.</p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-xl font-semibold text-gray-900">
            Does checking my limit guarantee approval?
          </h2>
          <p className="font-medium">No.</p>
          <p>
            Checking your credit limit is an eligibility assessment, not a
            guarantee of future borrowing. Approval depends on our assessment,
            and your available limit may change over time.
          </p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-xl font-semibold text-gray-900">
            Is my information secure?
          </h2>
          <p className="font-medium">Yes.</p>
          <p>
            Your information is encrypted and handled securely. It is used only
            for identity verification, fraud prevention, risk assessment, and
            providing Visaro services. We do not sell your personal information.
          </p>
        </section>
      </div>
    </div>
  );
};

export default CreditLimitInfo;
